import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";
import { useCheckLoginStatus } from "../../Hooks/checkLoginStatus";

const ProfileCompleationCheck = ({ children }) => {
  const { data } = useSelector((state) => state.login);
  const profile = JSON.parse(localStorage.getItem("cred"));
  const checkLoginStatus = useCheckLoginStatus();

  useEffect(() => {
    const interval = setInterval(() => {
      checkLoginStatus();
    }, 1000);

    return () => clearInterval(interval);
  }, [checkLoginStatus]);
  if (profile === null || !data.token) {
    localStorage.removeItem("cred");
    <Navigate to="/auth/login" />;
  }
  if (data) {
    if (
      !data.profile?.profileCompletion ||
      !data.profile?.bankAccountCompletion
    ) {
      return <Navigate to="/fill/detailsnew" />;
    } else {
      return children;
    }
  }
};

export default ProfileCompleationCheck;
